export const environment = {
  appName: "WHITELOTUS ADMIN",
  production: true,

    // apiUrl: 'https://api.hotelwhitelotus.in/',
    //apiUrl:'http://192.168.0.131:4000/',
    apiUrl:'https://api.hometowngalleria.in/',
    oneSignalAppId: 'c382baff-142f-4e16-b7c4-f6133d400ea4', //dev
   // media_domain: 'http://3.110.166.108:4000/amenities_image/',//dev
    media_domain: 'https://d1kr5bfvr1pyp0.cloudfront.net/production',
    //dev
   // media_domain: 'http://3.110.166.108:4002/',
    apiPrefix: 'api/v1',


  // appName: "WHITELOTUS ADMIN",
  // production: true,

  // // apiUrl: 'https://api-summer.manipal.edu/',
  //  apiUrl: 'https://api.hotelwhitelotus.in/',
  // //apiUrl:'http://3.110.166.108:4000/',
  // oneSignalAppId: 'c382baff-142f-4e16-b7c4-f6133d400ea4', //dev
  // media_domain: 'https://api.hotelwhitelotus.in/amenities_image/',//dev
  // apiPrefix: 'api/v1',
};
